// src/App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import VerInicio from './Web/ver/verinicio';
import Loginbinder from './Movil/loginbinder';
import VerUsuarios from './Web/ver/verusuarios';
import VerIngreso from './Web/ver/veringreso';
import VerCliente from './Web/ver/vercliente';
import VerPallets from './Web/ver/VerPallets';
import VerOperaciones from './Web/ver/VerOperacion';
import VerEgreso from './Web/ver/VerEgreso';
import VerPedidos from './Web/ver/VerPedidos';
import VerPerfil from './Web/ver/VerPerfil';
import VerUsuariosOperaciones from './Web/ver/verUsuariosOperaciones';
import VerInicioOperaciones from './Web/ver/verInicioOperaciones';
import General from './Movil/InicioGeneral';
import InicioGeneralOperaciones from './Movil/ver/inicioGeneralOperaciones';
import InicioGeneralGestion from './Movil/ver/inicioGeneralGestion';
import { UserIdProvider, useUserId } from './UserIdContext';
import VerIngresoprueba from './Web/ver/VerIngresomk';
import VerOperacionesDia from './Web/ver/VerOperacionesDia';
import VerAnularRemito from './Web/ver/veranularremito';
import VerModificarIngreso from './Web/ver/VerModificarIngreso';
import VerRemitosAnulados from './Web/ver/verremitosanulados';
import VerFacturacion from './Web/ver/verfacturacion';
import VerConfiguracion from './Web/ver/VerConfiguracion';
import VerConfiguracionOperaciones from './Web/ver/VerConfiguracionOperaciones';
import { getAccessToken } from './lib/apiClient';
import NotificationCenter from './components/NotificationCenter';
import OperationNoticeWatcher from './components/OperationNoticeWatcher';
import AdminNotificationHub from './components/AdminNotificationHub';
/* ============ DevTools Guard con límite de intentos ============ */
function DevtoolsGuard() {
  const LS_KEY_ATTEMPTS = 'devtoolsAttempts';
  const LS_KEY_HARDLOCK = 'devtoolsHardLock';

  const [locked, setLocked] = useState(false);        // overlay temporal
  const [attempts, setAttempts] = useState(0);        // contador de intentos
  const [hardLock, setHardLock] = useState(false);    // bloqueo permanente

  // Cargar estado guardado
  useEffect(() => {
    const a = parseInt(localStorage.getItem(LS_KEY_ATTEMPTS) || '0', 10);
    const h = localStorage.getItem(LS_KEY_HARDLOCK) === '1';
    setAttempts(Number.isFinite(a) ? a : 0);
    setHardLock(h);
    if (h) setLocked(true);
  }, []);

  // Persistir cambios
  useEffect(() => {
    localStorage.setItem(LS_KEY_ATTEMPTS, String(attempts));
  }, [attempts]);

  useEffect(() => {
    localStorage.setItem(LS_KEY_HARDLOCK, hardLock ? '1' : '0');
  }, [hardLock]);

  // Incrementa intentos y aplica hard lock si corresponde
  const registerAttempt = () => {
    setAttempts(prev => {
      const next = prev + 1;
      if (next >= 3) {
        setHardLock(true);
        setLocked(true);
        // endurecer aún más la UI
        document.body.style.pointerEvents = 'none';
        document.body.style.userSelect = 'none';
      } else {
        setLocked(true);
      }
      return next;
    });
  };

  useEffect(() => {
    // Bloquea atajos comunes y cuenta intentos
    const onKey = (e) => {
      const k = e.key?.toLowerCase();
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (k === 'i' || k === 'j')) ||
        (e.ctrlKey && k === 'u')
      ) {
        e.preventDefault();
        e.stopPropagation();
        registerAttempt();
      }
    };
    window.addEventListener('keydown', onKey, { capture: true });

    // Heurística: diferencias de ventana + trampa de "debugger"
    let t;
    const detect = () => {
      const wideGap = Math.abs(window.outerWidth - window.innerWidth) > 160;
      const tallGap = Math.abs(window.outerHeight - window.innerHeight) > 160;

      const start = performance.now();
      // eslint-disable-next-line no-debugger
      debugger;
      const debugPause = performance.now() - start > 100;

      const isOpen = wideGap || tallGap || debugPause;
      if (isOpen) {
        registerAttempt();
      }
    };

    // Si ya está hardlock no hace falta seguir detectando,
    // pero mantenemos un intervalo corto para reforzar.
    if (!hardLock) {
      t = setInterval(detect, 700);
    }

    return () => {
      window.removeEventListener('keydown', onKey, { capture: true });
      if (t) clearInterval(t);
    };
  }, [hardLock]); // si se activa hardlock, limpia el intervalo en el próximo render

  useEffect(() => {
    // Deshabilita interacción en overlay temporal; en hardLock ya se fuerza arriba
    if (!hardLock) {
      document.body.style.pointerEvents = locked ? 'none' : 'auto';
      document.body.style.userSelect = locked ? 'none' : 'auto';
      return () => {
        document.body.style.pointerEvents = 'auto';
        document.body.style.userSelect = 'auto';
      };
    }
  }, [locked, hardLock]);

  if (!locked) return null;

  // Overlay (bloqueo). Si hardLock => sin botón de reintento.
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 999999,
        background: hardLock
          ? 'linear-gradient(180deg, rgba(229,72,77,.65), rgba(229,72,77,.85))'
          : 'linear-gradient(180deg, rgba(229,72,77,.25), rgba(229,72,77,.45))',
        backdropFilter: 'blur(2px)',
        color: '#fff',
        display: 'grid',
        placeItems: 'center',
        textAlign: 'center',
        padding: 24,
        pointerEvents: 'all'
      }}
      onContextMenu={(e) => e.preventDefault()}
    >
      <div
        style={{
          maxWidth: 560,
          background: 'rgba(0,0,0,.55)',
          border: '1px solid rgba(255,255,255,.2)',
          borderRadius: 16,
          padding: 24,
          boxShadow: '0 24px 64px rgba(0,0,0,.45)'
        }}
      >
        <h2 style={{ marginBottom: 8 }}>
          {hardLock ? 'Aplicación bloqueada' : 'Modo protegido'}
        </h2>

        {!hardLock ? (
          <>
            <p style={{ opacity: 0.9, margin: 0 }}>
              Cerrá las herramientas de desarrollador para continuar.
            </p>
            <p style={{ opacity: 0.85, marginTop: 8 }}>
              Intentos: <strong>{attempts}</strong> / 3
            </p>
            <p style={{ opacity: 0.7, fontSize: 13, marginTop: 8 }}>
              (F12 / Ctrl+Shift+I / Ctrl+Shift+J / Ctrl+U)
            </p>
            <button
              type="button"
              onClick={() => setLocked(false)}
              style={{
                marginTop: 16,
                background: '#2BB673',
                border: '1px solid #22965c',
                color: '#fff',
                borderRadius: 10,
                padding: '10px 14px',
                cursor: 'pointer'
              }}
            >
              Reintentar
            </button>
          </>
        ) : (
          <>
            <p style={{ opacity: 0.9, margin: 0 }}>
              Se detectaron intentos repetidos de abrir la consola
              (<strong>{attempts}</strong> / 3). La aplicación quedó bloqueada.
            </p>
            <p style={{ opacity: 0.8, marginTop: 10, fontSize: 13 }}>
              Cerrá esta pestaña y volvé a ingresar. (El bloqueo persiste hasta limpiar el
              almacenamiento del navegador o reiniciar políticas.)
            </p>
          </>
        )}
      </div>
    </div>
  );
}
/* ========================================================= */

/* ============ Restriccion por rol (bloquea Visualizador Logistica) ============ */
const BlockLogisticaRoute = ({ children }) => {
  const { isLogistica } = useUserId();
  if (isLogistica) {
    return <Navigate to="/iniciogeneral" replace />;
  }
  return children;
};

const RequireAuthRoute = () => {
  if (!getAccessToken()) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

function App() {
  return (
    <>
      <NotificationCenter />
      <UserIdProvider>
        <OperationNoticeWatcher />
        <Router>
          <AdminNotificationHub />
          <Routes>
            <Route path="/" element={<Loginbinder />} />
            <Route element={<RequireAuthRoute />}>
              <Route
                path="/inicio"
                element={(
                  <BlockLogisticaRoute>
                    <VerInicio />
                  </BlockLogisticaRoute>
                )}
              />
              <Route
                path="/usuarios"
                element={(
                  <BlockLogisticaRoute>
                    <VerUsuarios />
                  </BlockLogisticaRoute>
                )}
              />
              <Route
                path="/ingreso"
                element={(
                  <BlockLogisticaRoute>
                    <VerIngreso />
                  </BlockLogisticaRoute>
                )}
              />
              <Route
                path="/anularremito"
                element={(
                  <BlockLogisticaRoute>
                    <VerAnularRemito />
                  </BlockLogisticaRoute>
                )}
              />
              <Route
                path="/remitos-anulados"
                element={(
                  <BlockLogisticaRoute>
                    <VerRemitosAnulados />
                  </BlockLogisticaRoute>
                )}
              />
              <Route
                path="/modificar-ingreso"
                element={(
                  <BlockLogisticaRoute>
                    <VerModificarIngreso />
                  </BlockLogisticaRoute>
                )}
              />
              <Route
                path="/cliente"
                element={(
                  <BlockLogisticaRoute>
                    <VerCliente />
                  </BlockLogisticaRoute>
                )}
              />
              <Route
                path="/pallets"
                element={(
                  <BlockLogisticaRoute>
                    <VerPallets />
                  </BlockLogisticaRoute>
                )}
              />
              <Route path="/operaciones" element={<VerOperaciones />} />
              <Route
                path="/egreso"
                element={(
                  <BlockLogisticaRoute>
                    <VerEgreso />
                  </BlockLogisticaRoute>
                )}
              />
              <Route
                path="/pedidos"
                element={(
                  <BlockLogisticaRoute>
                    <VerPedidos />
                  </BlockLogisticaRoute>
                )}
              />
              <Route
                path="/facturacion"
                element={(
                  <BlockLogisticaRoute>
                    <VerFacturacion />
                  </BlockLogisticaRoute>
                )}
              />
              <Route
                path="/perfil"
                element={(
                  <BlockLogisticaRoute>
                    <VerPerfil />
                  </BlockLogisticaRoute>
                )}
              />
              <Route path="/configuracion" element={<VerConfiguracion />} />
              <Route path="/iniciogeneral" element={<General />} />
              <Route path="/InicioGeneralOperaciones" element={<InicioGeneralOperaciones />} />
              <Route path="/InicioGeneralGestion" element={<InicioGeneralGestion />} />
              <Route
                path="/ingresoprueba"
                element={(
                  <BlockLogisticaRoute>
                    <VerIngresoprueba />
                  </BlockLogisticaRoute>
                )}
              />
              <Route
                path="/operacionesdia"
                element={(
                  <BlockLogisticaRoute>
                    <VerOperacionesDia />
                  </BlockLogisticaRoute>
                )}
              />
              <Route
                path="/UsuariosOperaciones"
                element={(
                  <BlockLogisticaRoute>
                    <VerUsuariosOperaciones />
                  </BlockLogisticaRoute>
                )}
              />
              <Route
                path="/configuracion-operaciones"
                element={<VerConfiguracionOperaciones />}
              />
              <Route path="/inicioOperaciones" element={<VerInicioOperaciones />} />
            </Route>
          </Routes>
        </Router>
      </UserIdProvider>
    </>
  );
}

export default App;
